import React from 'react';

// This exact standalone heading is appended by the Point 11 generator.
// With no heading, return historical content byte-for-byte to the original parser.
export const splitPoint11Content = (content = '') => {
  const marker = '\n\nKey Integrative Findings\n\n';
  const index = content.lastIndexOf(marker);
  if (index < 0) return { tableContent: content, findings: '' };
  return { tableContent: content.slice(0, index), findings: content.slice(index + 2) };
};

export const Point11Findings = ({ content }) => {
  const { findings } = splitPoint11Content(content);
  if (!findings) return null;
  return (
    <section className="mt-4" data-testid="point11-integrative-findings">
      <h5 className="font-semibold mb-2">Key Integrative Findings</h5>
      <div className="whitespace-pre-line">{findings.slice('Key Integrative Findings\n\n'.length).split(/(\n\n)/).map((part, index) => {
        const labelled = part.match(/^(\d+\. [^\n]+:)\n([^]*)$/);
        return labelled
          ? <React.Fragment key={index}><strong>{labelled[1]}</strong>{'\n' + labelled[2]}</React.Fragment>
          : <React.Fragment key={index}>{part}</React.Fragment>;
      })}</div>
    </section>
  );
};
